export type Bonus = {
  number: string
  title: string
  body: string
  /** URL pública de la portada. Vacío = se muestra una portada diseñada de respaldo. */
  cover: string
  accent: string
}

/**
 * Los 5 bonus reales del pack (ficha DPS66 · Ice Machine Diagnostic Pro, sección 6).
 * Cuando estén los mockups (DPS66 - Bono 1..5), pegá la URL pública en `cover`.
 */
export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Fillable Worksheet Pack',
    body: 'All 38 worksheets, WS-01 to WS-38, ready to fill on a tablet or phone and send to the manager before you leave the site. Print-ready versions included.',
    cover: '',
    accent: 'bg-ember',
  },
  {
    number: '02',
    title: 'The First-Week Ramp Plan',
    body: 'Seven days, one page each: the cards to read before that day’s calls, the one worksheet to use and the one habit to lock in. By day 7, the Split is how you start every call.',
    cover: '',
    accent: 'bg-sky',
  },
  {
    number: '03',
    title: '10 Worked Service Calls',
    body: 'Ten complete calls walked from the phone call to the signed report: what the tech saw, how the Split was applied, what was tested, what was wrong — and the worksheets as they were filled in.',
    cover: '',
    accent: 'bg-sys-refrig',
  },
  {
    number: '04',
    title: 'Field Units Conversion Card',
    body: 'Every unit you convert on an ice machine call — pressure, temperature, weight, volume, water hardness, BTU and watts — imperial and metric side by side, on one card for the van.',
    cover: '',
    accent: 'bg-moss',
  },
  {
    number: '05',
    title: 'Manual Finder & Wiring Symbol Guide',
    body: 'Find the right service manual for the exact model and serial in minutes, and read every symbol on an ice machine wiring diagram without guessing.',
    cover: '',
    accent: 'bg-bark',
  },
]
